import {
  NotificationProps,
  NotificationTypeEnum,
} from 'modules/notifications/types';
import notificationsKeys from 'modules/notifications/util/notifications-keys';
import React from 'react';
import StatusButton from 'shared/components/status-button';
import List from 'shared/layout/list';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';
import dateFnsService from 'shared/services/date-fns-service';

const Notifications: React.FC = () => {
  const projection = useProjection<NotificationProps>('notifications', [
    'id',
    'title',
    'body',
    'type',
    'day',
    'date',
    'time',
    'createdAt',
    'updatedAt',
    'active',
  ]);

  return (
    <List<NotificationProps>
      {...{
        titleBar: {
          title: 'Notificações',
          actionButton: {title: 'NOVA NOTIFICAÇÃO', to: 'create'},
        },
        table: {
          url: '/notifications',
          projection: {
            ...projection,
            options: [
              'title',
              'body',
              {
                value: 'type',
                column: (data) => (
                  <StatusButton
                    text={
                      data.type === NotificationTypeEnum.oneTime
                        ? 'Única'
                        : 'Recorrente'
                    }
                    variant={
                      data.type === NotificationTypeEnum.oneTime
                        ? 'success'
                        : 'info'
                    }
                  />
                ),
              },
              'day',
              'date',
              'time',
              {
                value: 'createdAt',
                column: (data) => dateFnsService.dateTimeFormat(data.createdAt),
              },
              {
                value: 'updatedAt',
                column: (data) => dateFnsService.dateTimeFormat(data.updatedAt),
              },
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      isChecked={row.active}
                      url={`/notifications/${row.id}`}
                      queryKey={notificationsKeys.list()}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
            ],
          },
          translatedPropsKey: 'NotificationProps',
        },
        queryKey: notificationsKeys.list(),
      }}
    />
  );
};

export default Notifications;
